module.exports = __webpack_public_path__ + "static/staff-tervor-479801e010de1ccebc890401095911de.png";